import { render, staticRenderFns } from "./needTaskDetails.vue?vue&type=template&id=8248cd04&scoped=true&"
import script from "./needTaskDetails.vue?vue&type=script&lang=js&"
export * from "./needTaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./needTaskDetails.vue?vue&type=style&index=0&id=8248cd04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8248cd04",
  null
  
)

export default component.exports